if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('click', this.onBackdropClick.bind(this));
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    }

    hide() {
      document.removeEventListener('keydown', this.onDocumentKeydown, true);
      super.hide();
      window.pauseAllMedia();
      this.unlockPageScroll();
    }

    show(opener) {
      this.setZoomImage(opener);
      super.show(opener);
      this.lockPageScroll();
      this.showActiveMedia();
      document.removeEventListener('keydown', this.onDocumentKeydown, true);
      document.addEventListener('keydown', this.onDocumentKeydown, true);
    }

    setZoomImage(opener) {
      const galleryImage = opener?.closest('.product__media-item')?.querySelector('img');
      const zoomImage = this.querySelector('.selfhoot-zoom-image');
      if (!galleryImage || !zoomImage) return;

      const source = galleryImage.currentSrc || galleryImage.src;
      if (!source) return;

      zoomImage.src = this.withImageWidth(source, 2200);
      zoomImage.srcset = this.withImageWidth(source, 1800) + ' 1800w, ' + this.withImageWidth(source, 2200) + ' 2200w';
      zoomImage.sizes = '(max-width: 749px) calc(100vw - 32px), 72vw';
      zoomImage.alt = galleryImage.alt || '';
    }

    withImageWidth(source, width) {
      try {
        const url = new URL(source, window.location.href);
        url.searchParams.set('width', width);
        return url.href;
      } catch (error) {
        const separator = source.includes('?') ? '&' : '?';
        return `${source}${separator}width=${width}`;
      }
    }

    onDocumentKeydown(event) {
      if (event.key === 'Escape' && this.hasAttribute('open')) {
        event.preventDefault();
        this.hide();
      }
    }

    showActiveMedia() {
      const openedMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      if (!openedMediaId) return;

      const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
      const activeMedia = mediaItems.find((element) => {
        const modalMediaId = element.getAttribute('data-media-id');
        return modalMediaId === openedMediaId || openedMediaId.endsWith(`-${modalMediaId}`);
      });

      if (!activeMedia) return;

      mediaItems.forEach((element) => element.classList.remove('is-active'));
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    onBackdropClick(event) {
      if (!this.hasAttribute('open') || event.target.closest('.product-media-modal__toggle')) return;

      const media = event.target.closest('.selfhoot-zoom-image');
      if (!media) this.hide();
    }

    lockPageScroll() {
      if (this.scrollLock) return;

      this.scrollLock = {
        x: window.scrollX,
        y: window.scrollY,
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
      };

      Object.assign(document.body.style, {
        position: 'fixed',
        top: `-${this.scrollLock.y}px`,
        left: `-${this.scrollLock.x}px`,
        right: '0',
        width: '100%',
      });
    }

    unlockPageScroll() {
      if (!this.scrollLock) return;

      const scrollLock = this.scrollLock;
      Object.assign(document.body.style, {
        position: scrollLock.position,
        top: scrollLock.top,
        left: scrollLock.left,
        right: scrollLock.right,
        width: scrollLock.width,
      });
      window.scrollTo(scrollLock.x, scrollLock.y);
      this.scrollLock = null;
    }
  });
}
